import React from 'react';
import classNames from 'classnames';

/**
 * A "chip" component that displays an image and some text with a background
 *
 * @module NackleRewardChip
 * @param {Object} props - the component props
 * @param {string} [props.src] - the reward chip image src
 * @param {string} [props.alt] - the reward chip image alt text
 * @param {boolean} [props.earned] - whether or not the reward has been earned
 * @param {string} [props.content] - the content of the reward chip
 * @param {string} [props.suffixText] - the suffix text for the reward chip
 * @param {string} [props.lazy] - the loading style of the reward chip
 * @param {string} [props.size] - the size of the reward chip (small, large, or default medium)
 *
 * @returns {React.ReactElement}
**/
const NackleRewardChip = ( { className, src, alt, earned, content, suffixText, lazy, size } ) => {
    let tileClasses = classNames( {
        'nackle-chip': true,
        'with-image': src ? true : false,
        earned: earned ? true : false,
        [ className ]: className ? true : false,
        [ size ]: size ? true : false
    } );
    return (
        <div className={ tileClasses }>
            { src &&
                <img className="chip-image" src={ src } alt={ alt } loading={ lazy ? 'lazy' : 'eager' } />
            }
            <div className="chip-content">
                { content }
            </div>
            <div className="chip-suffix">
                { suffixText }
            </div>
        </div>
    );
};

export { NackleRewardChip };
